
export default function TopicSearchResults({searchTerm, searchResults, total = null , limit}) {
  return (
    <>
      <div className={"search-results__wrapper"}>
        {searchResults.length > 0 &&
          <ul className="search-results__list">
            {searchResults.slice(0, limit).map((result, index) =>
              <li className={"search-result"} key={index}>
                <article className={"search-result__content"}>
                  <h4 className={"search-result__heading"}>
                    <a className={"search-result__link"} href={result.link}>{result.title}</a>
                  </h4>
                  <p className="search-result__meta">
                    <span className={"label label--small"}>Onderwerp</span>
                  </p>
                </article>
              </li>
            )}
          </ul>
        }
      </div>
    </>
  );
}
